<template>
  <div></div>
</template>

<script>
  import {Toast} from "vant"
  export default {
    name: "NovelBookShelf",
    props: {
      item: {
      },
      value: {}
    },

    data() {
      return {
        itemId: 0,
        isFav: false,
        listTypeBookShelf: "book_shelf",
        listTypeFavorite: "favorite",
      }
    },

    mounted () {
      this.itemId = this.item.id
      this.isFav = this.isFavorite(this.item)
    },

    methods: {
      onBookShelf() {
        if (this.isFav) {
          this.onClickRemove()
        } else {
          this.onClickAdd()
        }
      },
      onClickAdd() {
        this.isFav = true
        let params = {
          item_id: this.itemId,
          action: "add",
          list_type: this.listTypeBookShelf,
        }
        this.$store.dispatch("UpdateItemList", params).then((data)=> {
          if (data.code === 0) {
            Toast("加入书架")
          } else if(data.code === 20010) {
            Toast("未登录")
          } else {
            Toast("系统错误")
          }
        }, ()=> {
          Toast("网络异常")
        })

        let paramsV2 = {
          item_id: this.itemId,
          action: "add",
          list_type: this.listTypeFavorite,
        }
        this.$store.dispatch("UpdateItemList", paramsV2).then((data)=> {
        })
      },

      onClickRemove() {
        this.isFav = false
        let params = {
          item_id: this.itemId,
          action: "remove",
          list_type: this.listTypeBookShelf,
        }
        this.$store.dispatch("UpdateItemList", params).then((data)=> {
          if (data.code === 0) {
            Toast("移除书架")
          } else {
            Toast("系统错误")
          }
        }, ()=> {
          Toast("网络异常")
        })

        let paramsV2 = {
          item_id: this.itemId,
          action: "remove",
          list_type: this.listTypeFavorite,
        }
        this.$store.dispatch("UpdateItemList", paramsV2).then((data)=> {
        })
      },

      onClickAddCustom(listType) {
        let params = {
          item_id: this.itemId,
          action: "add",
          list_type: listType,
        }
        this.$store.dispatch("UpdateItemList", params).then((data) => {
          if (data.code === 0) {
          } else if (data.code === 20010) {
          } else {
          }
        }, () => {
          Toast("网络异常")
        })
      },

      onClickRemoveCustom(listType) {
        let params = {
          item_id: this.itemId,
          action: "remove",
          list_type: listType,
        }
        this.$store.dispatch("UpdateItemList", params).then((data) => {
          if (data.code === 0) {
          } else {
          }
        }, () => {
          Toast("网络异常")
        })
      },

      isFavorite(item) {
        if (!item || !item.item_list) {
          return false
        }
        if (!item.item_list.favorite) {
          return false
        } else {
          return true
        }
      }
    },
    watch: {
      isFav() {
        this.$emit("input", this.isFav)
      }
    }

  }

</script>

<style lang="scss" scoped>

  .option {
    color: rgba(180, 9, 13, 0.82);
    font-size: 16px;
  }

</style>
